import { render, staticRenderFns } from "./UserClosing.vue?vue&type=template&id=06f101c6&"
import script from "./UserClosing.vue?vue&type=script&lang=js&"
export * from "./UserClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f101c6')) {
      api.createRecord('06f101c6', component.options)
    } else {
      api.reload('06f101c6', component.options)
    }
    module.hot.accept("./UserClosing.vue?vue&type=template&id=06f101c6&", function () {
      api.rerender('06f101c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/closing/UserClosing.vue"
export default component.exports